import {EventEmitter, Injectable, Output} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {User} from './../../model/user';
import {LoginEvent} from '../../model/login-event';
import {MasbitHttpService} from '../../common/http/masbit-http.service';

@Injectable()
export class LoginService {

  private static readonly LOGIN_SERVICE_URL = environment.apiUrl.concat(environment.loginServiceUrl);

  @Output() loginEvent = new EventEmitter<LoginEvent>();
  private loginData : LoginEvent = {isAdmin:false, isClient:false, isUserLogged:false, sharedReportId: null, singleReportId: null};

  constructor(private httpClient: MasbitHttpService) {
  }

  public login(email: string, password: string, sharedReportId: string, ReportId: string) {
    return this.httpClient.get(LoginService.LOGIN_SERVICE_URL,new HttpParams().set('email', email).set('password', password) ).pipe(map((result: {token:string, user: User})=>{
      localStorage.setItem('auth_data', JSON.stringify(result));

      this.loginEvent.emit({isUserLogged : true, isClient : result.user.isClient, isAdmin : result.user.isAdmin, sharedReportId: sharedReportId, singleReportId: ReportId });
      this.loginData = {
        isUserLogged : true,
        isClient : result.user.isClient,
        isAdmin : result.user.isAdmin,
        sharedReportId: sharedReportId,
        singleReportId: ReportId
      };

      return result.user;
    }));
  }

  public logout() {
    localStorage.removeItem('auth_data');
    this.loginEvent.emit({isUserLogged : false, isClient : false, isAdmin : false, sharedReportId: null, singleReportId: null});
    this.loginData = {
      isAdmin : false,
      isClient : false,
      isUserLogged : false,
      sharedReportId: null,
      singleReportId: null
    };
  }

  public getLoginData() : LoginEvent {
    if (!this.loginData || !this.loginData.isUserLogged) {
      this.tryRestoreLoginData();
    }
    return this.loginData;
  }

  private tryRestoreLoginData() {
    if (!localStorage.getItem('auth_data')){
      return;
    }
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    this.loginEvent.emit({isUserLogged : true, isClient : authData.user.isClient, isAdmin : authData.user.isAdmin, sharedReportId: null, singleReportId: null});
    this.loginData = {
      isUserLogged : true,
      isClient : authData.user.isClient,
      isAdmin : authData.user.isAdmin,
      sharedReportId: null,
      singleReportId: null
    };
  }
}
